// Shared OCIA option lists + label maps used by the admin Details/Form components.
// (The public registration + payment pages keep their own bilingual copies.)

export const MARITAL_STATUS_OPTIONS = [
  { value: 'never-married', label: 'Never Married' },
  { value: 'engaged', label: 'Engaged to be Married' },
  { value: 'married', label: 'Married' },
  { value: 'separated', label: 'Married, but Separated' },
  { value: 'divorced', label: 'Divorced, Not Remarried' },
  { value: 'widowed', label: 'Widow/Widower, Not Remarried' }
];

export const OFFICIATING_AUTHORITY_OPTIONS = [
  { value: 'civil', label: 'Civil Government' },
  { value: 'non-christian-minister', label: 'Non-Christian Minister' },
  { value: 'christian-minister', label: 'Christian Minister' },
  { value: 'catholic-cleric', label: 'Catholic Cleric' }
];

export const BAPTIZED_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'unsure', label: 'Unsure' }
];

export const SACRAMENT_OPTIONS = [
  { value: 'penance', label: 'Penance (Confession)' },
  { value: 'eucharist', label: 'Eucharist (First Communion)' },
  { value: 'confirmation', label: 'Confirmation' }
];

export const INTENT_OPTIONS = [
  { value: 'considering', label: 'Considering joining — needs more information' },
  { value: 'fairly-sure', label: 'Fairly sure — needs time to study and pray' },
  { value: 'sure', label: 'Sure — will attend the classes' }
];

// Statuses that capture present-marriage details (date/place/officiating + partner).
export const MARITAL_NEEDS_MARRIAGE = ['married', 'separated', 'divorced', 'widowed'];
// Statuses that capture the other party (spouse or fiancé(e)).
export const MARITAL_NEEDS_PARTNER = ['engaged', 'married', 'separated', 'divorced', 'widowed'];

export const labelOf = (options, value) =>
  (options.find(o => o.value === value)?.label) || value || '';

export const ociaFullName = (r) =>
  [r?.firstName, r?.middleName, r?.lastName].filter(Boolean).join(' ');

export const formatPhoneNumber = (phone) => {
  const cleaned = ('' + (phone || '')).replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone || '';
};

export const formatAddress = (addr) => {
  if (!addr) return '';
  const { street, city, state, zip, country } = addr;
  return [street, city, state, zip, country].filter(Boolean).join(', ');
};
